module.exports = __webpack_public_path__ + "img/mobile.24b836bf.svg";